import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Reports</h1>
            <p className="mb-0">Final Destination Reports</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/final-destination-report/view-header.js